export default __webpack_public_path__ + "static/media/ig.d8469606.svg";